import { render } from "./VueInfo.vue?vue&type=template&id=70748a20&scoped=true"
import script from "./VueInfo.vue?vue&type=script&lang=js"
export * from "./VueInfo.vue?vue&type=script&lang=js"

import "./VueInfo.vue?vue&type=style&index=0&id=70748a20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70748a20"]])

export default __exports__